// extracted by mini-css-extract-plugin
export var chevron = "_22-d";
export var disabled = "_22-b";
export var error = "_22-c";
export var hideBorder = "_22-1";
export var icon = "_22-e";
export var input = "_22-0";
export var large = "_22-f";
export var open = "_22-9";
export var placeholder = "_22-a";
export var regular = "_22-5";
export var singleRowInput = "_22-2";
export var singleSelectInput = "_22-3 _22-0";
export var small = "_22-4";
export var spinnerContainer = "_22-i";
export var tag = "_22-7";
export var tagsContainer = "_22-8";
export var tagsInput = "_22-6 _22-0";
export var xSmall = "_22-g";
export var xxSmall = "_22-h";